import { render, staticRenderFns } from "./editAddModal.vue?vue&type=template&id=25b99661&scoped=true&"
import script from "./editAddModal.vue?vue&type=script&lang=js&"
export * from "./editAddModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b99661",
  null
  
)

export default component.exports